import React from "react";
import {
  Box,
  chakra,
  Container,
  Image,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
} from "@chakra-ui/react";
import { FaInstagram, FaFacebook } from "react-icons/fa";

import logo from "../logo.png";
import { EmailIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};
const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      bg={useColorModeValue("gray.200", "gray.900")}
      color={useColorModeValue("gray.900", "gray.200")}
    >
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        <Image boxSize="50px" objectFit="cover" src={logo} alt="Dan Abramov" />
        <Text>
          globaltrading.pk@yahoo.com © 2022 Global Trading. {t("rights")}
        </Text>
        <Stack direction={"row"} spacing={8}>
          <SocialButton label={"email"} href={"globaltrading.pk@yahoo.com"}>
            <EmailIcon />
          </SocialButton>
          <SocialButton
            label={"facebook"}
            href={"https://www.facebook.com/Globaltradingdotpk"}
          >
            <FaFacebook />
          </SocialButton>
          <SocialButton
            label={"Instagram"}
            href={"https://www.instagram.com/_u/globaltradingdotpk"}
          >
            <FaInstagram />
          </SocialButton>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
